import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const OfficeCleaningPage = lazy(() => import('../pages/services/office-cleaning/page'));
const RetailCleaningPage = lazy(() => import('../pages/services/retail-cleaning/page'));
const MedicalFacilityCleaningPage = lazy(() => import('../pages/services/medical-facility-cleaning/page'));
const IndustrialCleaningPage = lazy(() => import('../pages/services/industrial-cleaning/page'));
const WindowCleaningPage = lazy(() => import('../pages/services/window-cleaning/page'));
const SpecializedServicesPage = lazy(() => import('../pages/services/specialized-services/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services/office-cleaning',
    element: <OfficeCleaningPage />,
  },
  {
    path: '/services/retail-cleaning',
    element: <RetailCleaningPage />,
  },
  {
    path: '/services/medical-facility-cleaning',
    element: <MedicalFacilityCleaningPage />,
  },
  {
    path: '/services/industrial-cleaning',
    element: <IndustrialCleaningPage />,
  },
  {
    path: '/services/window-cleaning',
    element: <WindowCleaningPage />,
  },
  {
    path: '/services/specialized-services',
    element: <SpecializedServicesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
